<template>
  <el-card class="h-full ys-monitor-wrapper" :body-style="{ height: '100%' }">
    <div class="h-[calc(100%-40px)] w-full mb-10px">
      <!-- 一、四、九宫格 -->
      <div class="flex w-full h-full flex-wrap justify-around items-center" :class="gridClass">
        <div
          :key="index"
          @click="setCurVideoIndex(index)"
          v-for="(item, index) in monitorList"
          class="grid-item p-2px"
          :class="{ 'select-grid-item': curPlayIndex === index }"
        >
          <div class="h-full w-full" v-if="item.code">
            <NewYSPlayer :code="item.code" :name="item.name" :pIid="item.pIid"></NewYSPlayer>
          </div>
          <MonitorEmpty v-else></MonitorEmpty>
        </div>
      </div>
    </div>

    <!-- 底部工具栏 -->
    <div class="bottom-btns flex justify-center items-center h-30px leading-30px">
      <!-- <div class="icon-item">
        <img
          @click="minHandle"
          v-if="isFullScreen"
          src="@/assets/images/video-monitor/max-select.png"
        />
        <img @click="maxHandle" v-else src="@/assets/images/video-monitor/max.png" />
      </div> -->
      <div class="icon-item" @click="gridShowHandle(1)">
        <img v-if="monitorNum === 1" src="@/assets/images/video-monitor/one-grid-select.png" />
        <img v-else src="@/assets/images/video-monitor/one-grid.png" />
      </div>
      <div class="icon-item" @click="gridShowHandle(4)">
        <img v-if="monitorNum === 4" src="@/assets/images/video-monitor/four-grid-select.png" />
        <img v-else src="@/assets/images/video-monitor/four-grid.png" />
      </div>
      <!-- <div class="icon-item" @click="gridShowHandle(6)">
        <img v-if="monitorNum === 6" src="@/assets/images/video-monitor/six-grid-select.png" />
        <img v-else src="@/assets/images/video-monitor/six-grid.png" />
      </div> -->
      <div class="icon-item" @click="gridShowHandle(9)">
        <img v-if="monitorNum === 9" src="@/assets/images/video-monitor/nine-grid-select.png" />
        <img v-else src="@/assets/images/video-monitor/nine-grid.png" />
      </div>
    </div>
  </el-card>
</template>

<script>
import NewYSPlayer from '@/components/video/YSPlayer/NewYSPlayer'
import MonitorEmpty from './MonitorEmpty'

export default {
  name: 'ysMonitor',
  components: {
    MonitorEmpty,
    NewYSPlayer,
  },
  props: {
    defaultMonitorList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      monitorNum: 1,
      isFullScreen: false,
      curPlayIndex: 0,
      monitorList: [{}],
    }
  },
  methods: {
    minHandle() {},

    maxHandle() {},

    gridShowHandle(gridNumber) {
      this.monitorNum = gridNumber
      this.monitorList =
        this.defaultMonitorList.length >= gridNumber
          ? _.slice(this.defaultMonitorList, 0, gridNumber)
          : _.concat(
              _.slice(this.defaultMonitorList, 0, this.defaultMonitorList.length),
              new Array(gridNumber - this.defaultMonitorList.length).fill({})
            )
    },

    setCurVideoIndex(index) {
      this.curPlayIndex = index
    },

    playVideo(info) {
      this.$set(this.monitorList, this.curPlayIndex, info)
    },
  },
  computed: {
    gridClass() {
      const num = this.monitorNum
      if (num === 1) {
        return 'one-grid-box'
      }
      if (num === 4) {
        return 'four-grid-box'
      }
      if (num === 9) {
        return 'nine-grid-box'
      }
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.ys-monitor-wrapper {
  .select-grid-item {
    border: 5px solid var(--systemMainColor) !important;
  }

  .one-grid-box {
    background: var(--collapseHeadHeaderBg);

    .grid-item {
      height: 100%;
      width: 100%;
      border: 1px solid transparent;
    }
  }

  .four-grid-box {
    display: flex;

    .grid-item {
      width: calc(50% - 5px);
      height: calc(50% - 5px);

      background: var(--collapseHeadHeaderBg);
      border: 1px solid transparent;

      // &:nth-child(2n) {
      //   margin-right: 0;
      // }
    }
  }

  .six-grid-box {
    display: flex;
    flex-direction: column;

    .grid-top {
      flex: 1;
      display: flex;

      .grid-left {
        flex: 1;
        margin-right: 10px;
        margin-bottom: 10px;
        background: var(--collapseHeadHeaderBg);
        border: 1px solid transparent;
      }

      .grid-right {
        margin-bottom: 10px;
        width: calc((100% / 3) - 7.5px);

        .grid-item {
          height: calc(50% - 5px);
          background: var(--collapseHeadHeaderBg);
          border: 1px solid transparent;

          &:first-child {
            margin-bottom: 10px;
          }
        }
      }
    }

    .grid-bottom {
      display: flex;
      height: calc((100% / 3) - 7.5px);

      .grid-item {
        margin-right: 10px;
        flex: 1;
        background: var(--collapseHeadHeaderBg);
        border: 1px solid transparent;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .nine-grid-box {
    display: flex;
    flex-wrap: wrap;

    .grid-item {
      margin-right: 10px;
      margin-bottom: 10px;
      width: calc((100% / 3) - 7.5px);
      height: calc((100% / 3) - 7.5px);
      background: var(--collapseHeadHeaderBg);
      border: 1px solid transparent;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }

  .bottom-btns {
    display: flex;
    justify-content: center;
    align-items: center;

    .icon-item {
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>
